import { useContext, useEffect } from 'react';
import { PullToRefreshContext } from '../contexts/PullToRefreshContext';

/**
 * Register this page's refresh logic with the app-wide native pull-to-refresh
 * handler. Clears on unmount so the next route can register its own handler.
 *
 * @param {(() => void | Promise<void>) | null | undefined} onRefresh
 */
export function useRegisterPullToRefresh(onRefresh) {
  const ctx = useContext(PullToRefreshContext);

  useEffect(() => {
    if (!ctx || !onRefresh) return undefined;
    ctx.setRefreshHandler(onRefresh);
    return () => ctx.setRefreshHandler(null);
  }, [ctx, onRefresh]);
}
